import React, { useEffect, useState } from "react";
import { api, inr, imageUrl } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function CombosPage() {
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/combos").then((r) => setCombos(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold">
        Combo <span className="text-hyd-gold">packs</span>
      </h1>
      <p className="text-hyd-text2 mt-1">Everything you need in one add-to-cart. Perfect for gifting.</p>
      {loading ? (
        <div className="py-12 text-center text-hyd-text2">Loading...</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-5">
          {combos.map((cb) => (
            <ProductCard key={cb.id} product={cb} kind="combo" />
          ))}
        </div>
      )}
    </div>
  );
}
